﻿import { DisplayValues, UserDisplayName } from "@/components";
import { autoCompleteValueType } from "@/propTypes";
import { useGetUsersByIdsMutation } from "@/services";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { getDisplayValue } from "./helper";

export const UserAutoCompleteDisplay = ({ value }) => {
  const intl = useIntl();

  const [displayValues, setDisplayValues] = useState([]);

  const [getUsersById, { isFetching }] = useGetUsersByIdsMutation();

  useEffect(() => {
    if (!value?.length) return;

    getUsersById(Array.isArray(value) ? value : [value])
      .unwrap()
      .then((users) => {
        const values = users.map((user, index) => {
          const displayValue = getDisplayValue(user);

          if (user.AzureAdAccountEnabled === false) {
            return (
              <UserDisplayName
                key={index}
                displayName={displayValue}
                userAccountEnabled={user.AzureAdAccountEnabled}
              />
            );
          }

          return displayValue;
        });

        setDisplayValues(values);
      });
  }, [value, getUsersById]);

  return (
    <DisplayValues
      values={displayValues}
      type={intl.formatMessage({ id: "users.user" })}
      loading={isFetching}
    />
  );
};

UserAutoCompleteDisplay.propTypes = {
  value: autoCompleteValueType.isRequired,
};
